
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { HttpClient } from '@angular/common/http'
import { Meta, Title } from '@angular/platform-browser'
import { NnDateTime } from '../nn-date-time'
import { Router, RouterModule } from '@angular/router'
import { SITE_TITLE } from '../../../shared/constants'

@Component({
  selector: 'app-age-calculator',
  imports: [
    FormsModule,
    RouterModule
],
  templateUrl: './age-calculator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './age-calculator.component.scss'
})
export class AgeCalculatorComponent {

  constructor(
    private meta: Meta,
    private title: Title,
    public http: HttpClient,
    private router: Router,
  ) {

  }

  startDate!: string
  endDate!: string

  result: string = ''

  difference = {
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  differenceHumanReadable = {
    years: 0,
    months: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  }

  ngOnInit() {
    this.title.setTitle(SITE_TITLE + " | Age Calculation Tool")
    this.meta.updateTag({ name: 'description', content: 'Use this tool to calculate age between two dates. It provides the result in years, months, days, hours, minutes, and seconds.' })
    this.meta.updateTag({ name: 'keywords', content: 'age calculator, date difference, age calculation tool, calculate age, birth date calculator, age in years, months, days, age tool, free age calculator' })

    this.calculateDifference()
  }

  setEndDateToToday() {
    this.endDate = new Date().toISOString()
    this.calculateDifference()
  }

  calculateDifference() {
    if (this.endDate == null || this.endDate.trim() == '') {
      this.endDate = new Date().toISOString()
    }

    const start = new Date(this.startDate)
    const end = new Date(this.endDate)

    if (start && end) {
      const nnStart = new NnDateTime(start)
      const { days, hours, minutes, seconds } = nnStart.difference(end)
      this.difference = { days, hours, minutes, seconds }

      const { years, months, days: remainingDays } = nnStart.humanReadableDifference(end)
      this.differenceHumanReadable = { years, months, days: remainingDays, hours, minutes, seconds }

      this.result = `Difference: ${this.difference.days} days, ${this.difference.hours} hours, ${this.difference.minutes} minutes, ${this.difference.seconds} seconds`

      this.result += `\nHuman Readable: ${this.differenceHumanReadable.years} years, ${this.differenceHumanReadable.months} months, ${this.differenceHumanReadable.days} days, ${this.differenceHumanReadable.hours} hours, ${this.differenceHumanReadable.minutes} minutes, ${this.differenceHumanReadable.seconds} seconds`

      this.generateAgeTable(nnStart)
    } else {
      this.result = 'Please enter valid dates and times.'
    }
  }

  ageTable: { year: number; age: number }[] = [];

  generateAgeTable(nnStart: NnDateTime) {
    let birth = new Date(nnStart.date).getFullYear();
    let death = birth + 100

    let year = 0;

    for (year = birth + 1; year <= death; year++) {
      this.ageTable.push({ year: year, age: year - birth });
    }

    console.table(this.ageTable);
  }

  resetForm() {
    this.startDate = new Date(new Date().setDate(new Date().getDate() - 7)).toISOString()
    this.endDate = new Date(new Date()).toISOString()
  }
}
